import React, { createContext, useReducer, useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';

import {
  initialState,
  SnackbarState,
  reducer,
  enqueueSnackbar as enqueueSnackbarAction,
  closeSnackbar as closeSnackbarAction,
  Snackbar,
} from './snackbarReducer';

interface SnackbarsContextInterface {
  snackbarVisible: boolean;
  state: SnackbarState;
  enqueueSnackbar: (snackbar: Snackbar) => void;
  closeSnackbar: (key?: string) => void;
}

export const SnackbarsContext = createContext<SnackbarsContextInterface>({
  snackbarVisible: false,
  state: initialState,
  enqueueSnackbar: () => {},
  closeSnackbar: () => {},
});

export const SnackbarStoreProvider = ({
  children,
}: React.PropsWithChildren<any>): React.ReactElement => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const enqueueSnackbar = ({
    dismissible = true,
    key = uuidv4(),
    ...snackbarOg
  }: Snackbar) => {
    const snackbar = { ...snackbarOg, dismissible, key };

    dispatch(enqueueSnackbarAction(snackbar));

    if (snackbar.autoHideDuration) {
      setTimeout(() => {
        closeSnackbar(snackbar?.key);
      }, snackbar.autoHideDuration);
    }
  };

  const closeSnackbar = (key?: string) => dispatch(closeSnackbarAction(key));

  const snackbarVisible = state.snackbars.length > 0;

  return (
    <SnackbarsContext.Provider
      value={{ state, enqueueSnackbar, closeSnackbar, snackbarVisible }}
    >
      {children}
    </SnackbarsContext.Provider>
  );
};

export const useSnackbarsContext = () => useContext(SnackbarsContext);
